import { type PropsWithChildren } from "react"
import { Typography, type TypographyProps } from "@octopus-energy/coral/atoms"

type DashboardLayoutTitleProps = PropsWithChildren<TypographyProps>

export function DashboardLayoutTitle({ children, ...props }: DashboardLayoutTitleProps) {
    return (
        <Typography
            component="h2"
            textStyle="h4"
            textWrap="pretty"
            textAlign={{ base: "center", md: "start" }}
            {...props}
        >
            <b>{children}</b>
        </Typography>
    )
}
